module.exports = __webpack_public_path__ + "img/qr-temp.42c8651e.png";